module.exports = __webpack_public_path__ + "media/images/flags/TW-ba860637c5d6328e49cd2f1b49ba2c2f.svg";